import type { ReactNode } from "react";

/** Layout wrapper. Deliberately contains no motion. */
export function Section({
  id,
  labelledBy,
  tone = "base",
  children,
}: {
  id?: string;
  labelledBy?: string;
  tone?: "base" | "surface";
  children: ReactNode;
}) {
  return (
    <section id={id} aria-labelledby={labelledBy} data-tone={tone} className="section">
      <div className="shell">{children}</div>
    </section>
  );
}
